<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.3333 3.19922H4.66667C3.19391 3.19922 2 4.39313 2 5.86589V12.0881C2 13.5609 3.19391 14.7548 4.66667 14.7548H6.44444L10 17.4214V14.7548H15.3333C16.8061 14.7548 18 13.5609 18 12.0881V5.86589C18 4.39313 16.8061 3.19922 15.3333 3.19922Z"
      stroke="currentColor"
      stroke-width="1.5"
    />
  </svg>
</template>
